<nb-card>
  <nb-card-header>
    <h3>
      <tui-icon icon="@tui.bug"/>
      <span i18n="@@Error">Ошибка</span>
    </h3>
  </nb-card-header>
  <nb-card-body>
    <p>{{ getErrorText() }}</p>
    <a *ngIf="!environment.isOpenCabinet" class="admin-only" href="/cabinet/security/administrators/logs#files" target="_blank">Последние записи из текстовых логов</a>
  </nb-card-body>
  <nb-card-footer>
    <button nbButton status="primary" (click)="dismiss()" i18n="@@Ok" tuiAutoFocus>OK</button>
  </nb-card-footer>
</nb-card>
